import React, { useEffect } from 'react';

import { useMutation } from '@betterment/js-runtime';
import { Box } from '@betterment/samba-react';
import { Button, CenteredWorkflowLayout, FormikField, Heading } from '@betterment/style-closet-react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { DirectDepositConfig, DirectDepositStepProps } from './data';
import { useTitleDispatch } from './utils';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { useAccount } from '../AccountProvider';

interface FormProps {
  employerName: string;
}

const FormSchema = Yup.object().shape<Partial<{}>>({
  employerName: Yup.string().required('Employer name cannot be blank'),
});

export const EmployerName: React.FC<React.PropsWithChildren<DirectDepositStepProps>> = ({
  goToNextStep,
  flowState,
}) => {
  const { account } = useAccount();
  const setTitle = useTitleDispatch();
  const { employerName } = flowState.values;
  const [updateDirectDepositConfig] = useMutation<{}, DirectDepositConfig>(
    urlBuilder.apiV2CheckingDirectDepositConfig.absolute({ accountId: account.id }),
    { method: 'put' }
  );
  const processForm = async (formValues: FormProps) => {
    await updateDirectDepositConfig({ employerName: formValues.employerName });
    goToNextStep({ employerName: formValues.employerName });
  };

  useEffect(() => setTitle('Direct deposit form'), [setTitle]);
  return (
    <>
      <Heading variant="primary">Who is your employer?</Heading>
      <Box
        css={{
          marginTop: 'space.300',
        }}
      >
        <Formik
          onSubmit={processForm}
          validationSchema={FormSchema}
          initialValues={{ employerName: employerName || '' }}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          {({ isSubmitting }) => (
            <Form>
              <FormikField id="employerName" name="employerName" label="Employer Name" as="string" />
              <CenteredWorkflowLayout.Actions>
                <Button type="submit" disabled={isSubmitting}>
                  Save
                </Button>
              </CenteredWorkflowLayout.Actions>
            </Form>
          )}
        </Formik>
      </Box>
    </>
  );
};
